<template>
  <div class="startSys xstart">
    <div></div>
    <div v-if="isTips">
      <div
        class="mock_info"
        v-if="examType === '模考'"
      >
        <h1>Select Section Order</h1>
        <p style="width: 95%; margin: 10px auto">
          Select the order in which the exam sections are to be administered.
        </p>
        <p style="width: 95%; margin: auto; line-height: 30px; color: red">
          You have one (1) minute to make your selection in the GMAT exam. If you do not make your selection within one (1) minute, the first option listed will be selected, and you will take the exam in the following order: Quantitative Reasoning, Verbal Reasoning, Data Insights.
        </p>
        <p style="width: 95%; margin: 10px auto">
          Please note that in the GMAT Focus Official Practice Exams, this screen is not timed.
          <br>
          Six different section order options are presented below. Once you select your section order, you must view ALL questions in each section, in the order you selected, before moving to the next section. You will NOT be able to return to this screen.
        </p>
        <div class="choiceSub">
          <h2>选择模考科目</h2>
          <!-- 第一部份 -->
          <!-- <div class="choiceCell" @click="extendT">
          <el-checkbox v-model="checkedExtend" :disabled="!questionNumberObj.awacount" @change="partCheckboxChange">Analytics Writing of Argument部分（{{questionNumberObj.awacount}}篇）</el-checkbox>
          <img src="@/assets/examinatSystem/sysArrow.png" alt="" />
        </div>
        <div class="extendCell" v-if="extendCells">
          <div class="extendTit">时间设置</div>
          <div class="extendText">
            <el-radio v-model="radio" :label="0">限制AWA部分总时长为30min（*建议）</el-radio>
            <el-radio v-model="radio" :label="1">不限时长</el-radio>
          </div>
        </div> -->
          <!-- 第二部份 -->
          <div
            class="choiceCell"
            @click="secondCells"
          >
            <el-checkbox
              v-model="checkedRea"
              :disabled="!questionNumberObj.dicount"
              @change="partCheckboxChange"
            >Data Insights部分（共{{
                questionNumberObj.dicount
              }}题）</el-checkbox>
            <img
              src="@/assets/examinatSystem/sysArrow.png"
              alt=""
            />
          </div>
          <div
            class="extendCell"
            v-if="secondsCell"
          >
            <div class="extendTit">
              <p>选项设置:</p>
              <p>时间设置:</p>
            </div>
            <div class="extendText">
              <el-checkbox v-model="checked">选项乱序显示</el-checkbox>
              <el-radio
                v-model="radioSecond"
                :label="0"
              >限制DI部分总时长为 45min（*建议）</el-radio>
              <!-- <el-radio v-model="radioSecond" :label="1">不限时长，超出pace时间提醒</el-radio> -->
              <el-radio
                v-model="radioSecond"
                :label="2"
              >限制每题做题时长为<input
                  @blur="timeChange($event, 2)"
                  class="cellInputs"
                  v-model="secondTime"
                />秒（可设置区间：20s-300s）</el-radio>
            </div>
          </div>
          <!-- 第三部分 -->
          <div
            class="choiceCell"
            @click="threeCells"
          >
            <el-checkbox
              v-model="checkeThree"
              :disabled="!questionNumberObj.qcount"
              @change="partCheckboxChange"
            >Quantitative部分（共{{
                questionNumberObj.qcount
              }}题）</el-checkbox>
            <img
              src="@/assets/examinatSystem/sysArrow.png"
              alt=""
            />
          </div>
          <div
            class="extendCell"
            v-if="threeCell"
          >
            <div class="extendTit">
              <p>选项设置:</p>
              <p>时间设置:</p>
            </div>
            <div class="extendText">
              <el-checkbox v-model="checkThrees">选项乱序显示</el-checkbox>
              <el-radio
                v-model="thirdCell"
                :label="0"
              >限制Quant部分总时长为 45min（*建议）</el-radio>
              <!-- <el-radio v-model="thirdCell" :label="1">不限时长，超出pace时间提醒</el-radio> -->
              <el-radio
                v-model="thirdCell"
                :label="2"
              >限制每题做题时长为<input
                  @blur="timeChange($event, 3)"
                  class="cellInputs"
                  v-model="thirdTime"
                />秒（可设置区间：20s-300s）</el-radio>
            </div>
          </div>
          <!-- 第四部分 -->
          <div
            class="choiceCell"
            @click="fourthCells"
          >
            <el-checkbox
              v-model="checkeFour"
              :disabled="!questionNumberObj.vcount"
              @change="partCheckboxChange"
            >Verbal部分（共{{ questionNumberObj.vcount }}题）</el-checkbox>
            <img
              src="@/assets/examinatSystem/sysArrow.png"
              alt=""
            />
          </div>
          <div
            class="extendCell"
            v-if="fourCell"
          >
            <div class="extendTit">
              <p>选项设置:</p>
              <p>时间设置:</p>
            </div>
            <div class="extendText">
              <el-checkbox v-model="checkfourth">选项乱序显示</el-checkbox>
              <el-radio
                v-model="fourthCell"
                :label="0"
              >限制Verbal部分总时长为 45min（*建议）</el-radio>
              <!-- <el-radio v-model="fourthCell" :label="1">不限时长，超出pace时间提醒</el-radio> -->
              <el-radio
                v-model="fourthCell"
                :label="2"
              >限制每题做题时长为<input
                  @blur="timeChange($event, 4)"
                  class="cellInputs"
                  v-model="fourthTime"
                />秒（可设置区间：20s-300s）</el-radio>
            </div>
          </div>
          <!-- 选择考试顺序 -->
          <div class="examOrder">
            <p>
              选择考试顺序
              <el-popover
                placement="top-start"
                trigger="hover"
                content="可以自选顺序模考啦~"
              ><img
                  slot="reference"
                  src="@/assets/examinatSystem/doubtIconBlue.png"
                /></el-popover>
              <!-- <span class="add"
                >(本模拟题库暂未纳入AWA及IR习题，但为了模拟真实考试环境，以下仍然包含了AWA及IR的顺序选择)</span
              > -->
            </p>
            <div style="display: flex;flex-wrap: wrap;width: 500px;margin: 0 auto;">
              <div
                v-for="(item, index) in chooseList"
                :key="index"
                style="width: 33.33333%;margin:20px 0;"
              >
                <el-radio
                  v-model="fifthRadio"
                  :label="index"
                  @change="fifthRadioChange"
                >
                  <div
                    v-for="(z, i) in item"
                    :key="i"
                    :class="[
                      (checkeFour && z === 0) ||
                      (checkeThree && z === 1) ||
                      (checkedRea && z === 2)
                        ? ''
                        : 'ishide'
                    ]"
                  >
                    {{ dataList[z] }}
                  </div>
                  <!-- <span
                  :class="[checkedExtend ? '' : 'ishide']"
                  >Analytics Writing of Argument</span
                > -->
                </el-radio>
              </div>
            </div>
            <!-- <div class="examOrderCell">
              <el-radio
                v-model="fifthRadio"
                :label="0"
                @change="fifthRadioChange"
              >
                <span
                  style="display: flex"
                  :class="[checkedExtend ? '' : 'ishide']"
                  >Analytics Writing of Argument</span
                >
                <span
                  style="display: flex"
                  :class="[checkedRea ? '' : 'ishide']"
                  >Integrated Reasoning</span
                >
                <span
                  style="display: flex"
                  :class="[checkeThree ? '' : 'ishide']"
                  >Quantitative</span
                >
                <span
                  style="display: flex"
                  :class="[checkeFour ? '' : 'ishide']"
                  >Verbal</span
                >
              </el-radio>
              <el-radio
                v-model="fifthRadio"
                :label="1"
                @change="fifthRadioChange"
              >
                <span
                  style="display: flex"
                  :class="[checkeThree ? '' : 'ishide']"
                  >Quantitative</span
                >
                <span
                  style="display: flex"
                  :class="[checkeFour ? '' : 'ishide']"
                  >Verbal</span
                >
                <span
                  style="display: flex"
                  :class="[checkedRea ? '' : 'ishide']"
                  >Integrated Reasoning</span
                >
                <span
                  style="display: flex"
                  :class="[checkedExtend ? '' : 'ishide']"
                  >Analytics Writing of Argument</span
                >
              </el-radio>
              <el-radio
                v-model="fifthRadio"
                :label="2"
                @change="fifthRadioChange"
              >
                <span
                  style="display: flex"
                  :class="[checkeFour ? '' : 'ishide']"
                  >Verbal</span
                >
                <span
                  style="display: flex"
                  :class="[checkeThree ? '' : 'ishide']"
                  >Quantitative</span
                >
                <span
                  style="display: flex"
                  :class="[checkedRea ? '' : 'ishide']"
                  >Integrated Reasoning</span
                >
                <span
                  style="display: flex"
                  :class="[checkedExtend ? '' : 'ishide']"
                  >Analytics Writing of Argument</span
                >
              </el-radio> 
            </div> -->
            <div class="leftChoice">
            </div>
            <input
              type="button"
              value="开始练习"
              class="startBtns"
              @click="startExams"
              :disabled="startBtn"
            />
            <p
              class="stratTips"
              v-show="startBtn"
            >
              至少选择一个科目，才可以开始模考
            </p>
            <p class="startAdvise">
              建议：模考期间建议您将可能给您考试带来干扰的设备或软件调至静音状态。
            </p>
          </div>
        </div>
      </div>

      <!-- 练习 -->
      <div
        class="exercise"
        v-else
      >
        <!-- 练习册数据 -->
        <div class="workbook_title">练习册数据：</div>
        <ul class="workbook_content">
          <li>
            <div class="content_title">练习人数1</div>
            <div class="content_detail">{{ exercise.peoplenum }}人</div>
          </li>
          <li>
            <div class="content_title">题目总数</div>
            <div class="content_detail">{{ exercise.count }}</div>
          </li>
          <li>
            <div class="content_title">平均正确率</div>
            <div class="content_detail">{{ exercise.average }}%</div>
          </li>
          <!-- <li>
            <div class="content_title">建议用时</div>
            <div class="content_detail">29~46min</div>
          </li> -->
          <li>
            <div class="content_title">我上次做题正确率</div>
            <div class="content_detail">
              {{ Math.round((exercise.correct / exercise.count) * 150) }}%
            </div>
          </li>
          <li>
            <div class="content_title">我的耗时(最近一次)</div>
            <div class="content_detail">{{ exercise.usetime }}min</div>
          </li>
        </ul>
        <!-- 答题设置 -->
        <div class="setting">
          <div style="text-align: center; margin-top: 20px">
            <el-button
              type="primary"
              style="width: 164px"
              @click="startExams"
            >开始练习</el-button>
          </div>
        </div>
      </div>
    </div>
    <div v-show="!isTips">
      <explain
        ref="explain"
        :nextIndex="nextIndexs"
      />
    </div>
  </div>
</template>

<script>
import api from "@/api/dryRun.js";
import explain from "./explain";
export default {
  props: {
    nextIndexs: [String, Number],
    startText: Boolean,
  },
  watch: {
    nextIndexs: {
      handler() {
        console.log(this.nextIndexs, "开始考试");
      },
      deep: true,
      immediate: true,
    },
  },
  components: {
    explain,
  },
  data() {
    return {
      isTips: true,
      examType: "模考",
      // 是否乱序
      //第一部分
      radio: 0,
      checkedExtend: true,
      extendCells: false,
      //第二部分
      checkedRea: true,
      checked: true, //选项
      radioSecond: 0,
      secondsCell: false,
      //第三部分
      threeCell: false,
      checkeThree: true, //头部选择
      checkThrees: true, //选项
      thirdCell: 0, //时间
      //第四部分
      fourCell: false,
      checkeFour: true, //头部选择
      checkfourth: true, //选项
      fourthCell: 0, //时间
      fifthRadio: 0, //最下面的单选
      questionNumberObj: {
        //所有题目数量
        dicount: 0,
        qcount: 0,
        vcount: 0,
      },
      startBtn: false, //开始按钮
      secondTime: 20,
      thirdTime: 20,
      fourthTime: 20,
      exercise: {
        peoplenum: 0,
        count: 0,
        average: 100,
        correct: 0,
        usetime: 0,
      },
      dataList: ["Verbal", "Quantitative", "Data Insights"],
      chooseList: [],
    };
  },
  async created() {
    // 判断是模考还是练习
    if (this.$route.query.m_id) {
      this.examType = "练习";
      sessionStorage.setItem("m_id", this.$route.query.m_id);
      sessionStorage.setItem("nums", 1);
      sessionStorage.setItem("examType", "练习");
      const res = await api.getExerciseBook({
        id: this.$route.query.m_id,
      });
      // sessionStorage.setItem("title", res.data.data.title);
      // console.log(res.data.data.title + "1111");
      if (res.data.code === 0) {
        this.exercise = res.data.data;
      }
    } else if (this.$route.params.id) {
      this.examType = "模考";
      sessionStorage.setItem("m_id", this.$route.params.id);
      sessionStorage.setItem("nums", 1);
      sessionStorage.setItem("examType", "模考");
    }
  },
  mounted() {
    sessionStorage.removeItem("review");
    this.getParams();
  },
  methods: {
    // 防止每道题时间设置在20-300范围之外
    timeChange(e, index) {
      if (index === 2) {
        if (e.target.value < 20) {
          this.secondTime = 20;
        } else if (e.target.value > 300) {
          this.secondTime = 300;
        }
      } else if (index === 3) {
        if (e.target.value < 20) {
          this.thirdTime = 20;
        } else if (e.target.value > 300) {
          this.thirdTime = 300;
        }
      } else if (index === 4) {
        if (e.target.value < 20) {
          this.fourthTime = 20;
        } else if (e.target.value > 300) {
          this.fourthTime = 300;
        }
      }
    },
    // 选择要做的题的部分
    partCheckboxChange(e) {
      if (
        this.checkedRea === false &&
        this.checkeThree === false &&
        this.checkeFour === false
      ) {
        this.startBtn = true;
      } else {
        // 开始按钮样式
        this.startBtn = false;
      }
    },
    // 选择考试顺序
    fifthRadioChange(e) {
      this.fifthRadio = e;
    },
    go() {
      this.$router.push("/examInstructions");
    },
    //第一部分
    extendT() {
      if (!this.extendCells) {
        this.extendCells = true;
        this.secondsCell = this.threeCell = this.fourCell = false;
      } else {
        this.extendCells = false;
      }
    },
    //第二部分
    secondCells() {
      if (!this.secondsCell) {
        this.secondsCell = true;
        this.extendCells = this.threeCell = this.fourCell = false;
      } else {
        this.secondsCell = false;
      }
    },
    //第三部分
    threeCells() {
      if (!this.threeCell) {
        this.threeCell = true;
        this.secondsCell = this.extendCells = this.fourCell = false;
      } else {
        this.threeCell = false;
      }
    },
    //第四部分
    fourthCells() {
      if (!this.fourCell) {
        this.fourCell = true;
        this.secondsCell = this.extendCells = this.threeCell = false;
      } else {
        this.fourCell = false;
      }
    },
    clickNext() {
      if (!this.isTips) {
        this.isTips = true;
        this.$emit("isTips", false);
        //  this.$router.push({path:'/explain',query:{index:0}})
        return false;
      } else {
        const choose = this.chooseList[this.fifthRadio];
        let changIndex = 5;
        if (choose[0] === 1) {
          if (!this.checkeThree) {
            if (choose[1] === 0 && this.checkeFour) {
              changIndex = 6;
            } else {
              changIndex = 7;
            }
          }
        } else if (choose[0] === 0) {
          if (!this.checkeFour) {
            if (choose[1] === 1 && this.checkeThree) {
              changIndex = 5;
            } else {
              changIndex = 7;
            }
          } else {
            changIndex = 6;
          }
        } else if (choose[0] === 2) {
          if (!this.checkedRea) {
            if (choose[1] === 1 && this.checkeThree) {
              changIndex = 5;
            } else {
              changIndex = 6;
            }
          } else {
            changIndex = 7;
          }
        }
        this.$emit("changIndex", changIndex);
        this.isTips = false;
        this.$emit("isTips", true);
      }
    },
    //开始页面
    async startExams() {
      console.log(this.startText);
      // 以何种方式进入答题，模考还是练习
      if (this.examType === "模考") {
        this.$emit("isTips", false);
        let params = {
          sort: this.fifthRadio,
          m_id: sessionStorage.getItem("m_id"),
        };
        // 第一部分参数
        // 第二部分参数
        if (this.checkedRea) {
          params.DI = {
            isconfusion: this.checked ? 0 : 1,
          };
          if (this.radioSecond === 2) {
            params.DI.choice = 2;
            params.DI.duration = this.secondTime;
          } else {
            params.DI.choice = this.radioSecond;
          }
        }
        // 第三部分参数
        if (this.checkeThree) {
          params.Q = {
            isconfusion: this.checkThrees ? 0 : 1,
          };
          if (this.thirdCell === 2) {
            params.Q.choice = 2;
            params.Q.duration = this.thirdTime;
          } else {
            params.Q.choice = this.thirdCell;
          }
        }
        // 第四部分参数
        if (this.checkeFour) {
          params.V = {
            isconfusion: this.checkfourth ? 0 : 1,
          };
          if (this.fourthCell === 2) {
            params.V.choice = 2;
            params.V.duration = this.fourthTime;
          } else {
            params.V.choice = this.fourthCell;
          }
        }
        // 设置模考参数
        const res = await api.setParam(params);
        console.log("设置参数", res);
        if (res.data.code === 0) {
          console.log(res.data.data + "1234");
          // 保存当前考号
          sessionStorage.setItem("curId", res.data.data.examnumber);
          console.log("答题顺序", this.fifthRadio);
          const next = await api.next({
            id: res.data.data.examnumber,
            m_id: sessionStorage.getItem("m_id"),
          });
          if (
            next.data.code !== 0 ||
            !next.data.data.topic ||
            !next.data.data.topic.type
          ) {
            this.$message.error("获取题目失败!");
            return;
          }
          const fifthRadio = next.data.data.topic.type;
          if (this.isTips) {
            sessionStorage.setItem("nextType", fifthRadio);
            return this.clickNext();
          }
          const path = [
            "/singleChoice",
            "/completion",
            "/doubleChoice",
            "/singleChoiceBoolean",
            "/examinContent/systemRead",
            "/imageAnalysis",
            "/table",
            "/reasoning",
            "/choice"
          ];
          console.log(fifthRadio, 111);
          if (fifthRadio >= 1 && fifthRadio <= 9) {
            sessionStorage.setItem("isFirst", true);
            this.$router.push({
              path: path[fifthRadio - 1],
              query: {
                id: res.data.data.examnumber,
                m_id: sessionStorage.getItem("m_id"),
              },
            });
          } else {
            this.$message.error("题目类型错误");
            return;
          }
        } else {
          this.$message.error(res.data.msg);
        }
      } else {
        console.log("开始练习");
        this.$emit("isTips", false);
        const total = await api.startExercise({
          m_id: sessionStorage.getItem("m_id"),
          type: 0,
        });
        if (total.data.code == 0) {
          sessionStorage.setItem("curId", total.data.data.examnumber);
          if (!total.data.data.topic || !total.data.data.topic.type) {
            this.$message.error("获取题目失败!");
            return;
          }
          const fifthRadio = total.data.data.topic.type;
          const path = [
            "/singleChoice",
            "/completion",
            "/doubleChoice",
            "/singleChoiceBoolean",
            "/examinContent/systemRead",
            "/imageAnalysis",
            "/table",
            "/reasoning",
            "/choice"
          ];
          if (fifthRadio >= 1 && fifthRadio <= 9) {
            sessionStorage.setItem("isFirst", true);
            this.$router.push({
              path: path[fifthRadio - 1],
            });
          } else {
            this.$message.error("题目类型错误");
            return;
          }
        } else {
          this.$message.error(total.data.msg);
        }
      }
    },
    //设置模考参数
    getParams() {
      if (this.examType === "模考") {
        this.isTips = false;
        this.$emit("isTips", true);
      }
      let params = {
        m_id: sessionStorage.getItem("m_id"),
      };
      let query = this.$qs.stringify(params);
      // api.setParam(query).then(res => {
      //   console.log(res,'模考参数')
      // })
      // .catch(err => {
      //   this.$message.error('获取模考失败')
      // })
      api
        .getParam(query)
        .then((res) => {
          console.log("获取模考设置参数", res);
          if (res.data.code === 0) {
            this.questionNumberObj = res.data.data;
            if (this.questionNumberObj.dicount === 0) {
              this.checkedRea = false;
            }
            if (this.questionNumberObj.qcount === 0) {
              this.checkeThree = false;
            }
            if (this.questionNumberObj.vcount === 0) {
              this.checkeFour = false;
            }
            this.chooseList = res.data.data.sortlist;
          } else {
            this.$message.error("获取模考失败");
          }
        })
        .catch((err) => {
          this.$message.error("获取模考失败");
        });
    },
  },
};
</script>

<style scoped>
@import "../../assets/css/examinatStart.css";
.startSys {
  position: relative;
}
.leftChoice p span {
  width: 67px;
  height: 25px;
  margin-left: 3px;
  display: inline-block;
  background: url(../../assets/explainImg/next.png) no-repeat;
  background-size: contain;
}
</style>



// WEBPACK FOOTER //
// src/view/examinatSystem/examinatStart.vue